// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Log$SmartcutsMacros = require("../Log.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../bs-utils/src/DeccoUtils.bs.js");

var _map = {"link":"link","typed":"typed","auto_bookmark":"auto_bookmark","auto_subframe":"auto_subframe","manual_subframe":"manual_subframe","generated":"generated","start_page":"start_page","form_submit":"form_submit","reload":"reload","keyword":"keyword","keyword_generated":"keyword_generated"};

function tToJs(param) {
  return param;
}

function tFromJs(param) {
  return _map[param];
}

var TransitionType = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
      typeName: "Browser.WebNavigation.TransitionType.t",
      tToJs: tToJs,
      tFromJs: tFromJs
    });

var _map$1 = {"client_redirect":"client_redirect","server_redirect":"server_redirect","forward_back":"forward_back","from_address_bar":"from_address_bar"};

function tToJs$1(param) {
  return param;
}

function tFromJs$1(param) {
  return _map$1[param];
}

var TransitionQualifier = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
      typeName: "Browser.WebNavigation.transitionQualifier.t",
      tToJs: tToJs$1,
      tFromJs: tFromJs$1
    });

function transitionQualifiersFromJs(transitionQualifierStrings) {
  return $$Array.map((function (qualifierStr) {
                var transitionQualifierVariant = Curry._1(TransitionQualifier.tFromJs, qualifierStr);
                if (transitionQualifierVariant !== undefined) {
                  return transitionQualifierVariant;
                } else {
                  return Js_exn.raiseError("Unknown transitionType: " + qualifierStr);
                }
              }), transitionQualifierStrings);
}

function transitionQualifiersToJs(transitionQualifiers) {
  return $$Array.map(TransitionQualifier.tToJs, transitionQualifiers);
}

var EventFilter = {};

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "tabId",
                Decco.intToJson(v.tabId)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "frameId",
                Decco.intToJson(v.frameId)
              ],
              [
                "parentFrameId",
                Decco.intToJson(v.parentFrameId)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
  if (tabId.TAG === /* Ok */0) {
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
      if (frameId.TAG === /* Ok */0) {
        var parentFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentFrameId"), null));
        if (parentFrameId.TAG === /* Ok */0) {
          var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
          if (timeStamp.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      tabId: tabId._0,
                      url: url._0,
                      frameId: frameId._0,
                      parentFrameId: parentFrameId._0,
                      timeStamp: timeStamp._0
                    }
                  };
          }
          var e = timeStamp._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".timeStamp" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = parentFrameId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".parentFrameId" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = frameId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".frameId" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = tabId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tabId" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function stringify(param) {
  return "{tabId=" + (String(param.tabId) + (", url=" + (param.url + (", frameId=" + (String(param.frameId) + (", parentFrameId=" + (String(param.parentFrameId) + (", timeStamp=" + (param.timeStamp.toString() + "}")))))))));
}

var Details = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

var OnBeforeNavigate = {
  Details: Details
};

var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});

function record_encode(v) {
  return Js_dict.fromArray([
              [
                "tabId",
                Decco.intToJson(v.tabId)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "processId",
                Decco.intToJson(v.processId)
              ],
              [
                "frameId",
                Decco.intToJson(v.frameId)
              ],
              [
                "parentFrameId",
                Decco.intToJson(v.parentFrameId)
              ],
              [
                "transitionType",
                Curry._1(TransitionType.t_encode, v.transitionType)
              ],
              [
                "transitionQualifiers",
                Decco.arrayToJson(TransitionQualifier.t_encode, v.transitionQualifiers)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ]
            ]);
}

function record_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
  if (tabId.TAG === /* Ok */0) {
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      var processId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "processId"), null));
      if (processId.TAG === /* Ok */0) {
        var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
        if (frameId.TAG === /* Ok */0) {
          var parentFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentFrameId"), null));
          if (parentFrameId.TAG === /* Ok */0) {
            var transitionType = Curry._1(TransitionType.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "transitionType"), null));
            if (transitionType.TAG === /* Ok */0) {
              var transitionQualifiers = Decco.arrayFromJson(TransitionQualifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "transitionQualifiers"), null));
              if (transitionQualifiers.TAG === /* Ok */0) {
                var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                if (timeStamp.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            tabId: tabId._0,
                            url: url._0,
                            processId: processId._0,
                            frameId: frameId._0,
                            parentFrameId: parentFrameId._0,
                            transitionType: transitionType._0,
                            transitionQualifiers: transitionQualifiers._0,
                            timeStamp: timeStamp._0
                          }
                        };
                }
                var e = timeStamp._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".timeStamp" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = transitionQualifiers._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".transitionQualifiers" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = transitionType._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".transitionType" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = parentFrameId._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".parentFrameId" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = frameId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".frameId" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = processId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".processId" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = tabId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tabId" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function toRecord(details) {
  var tabId = details.tabId;
  var url = details.url;
  var processId = details.processId;
  var frameId = details.frameId;
  var parentFrameId = details.parentFrameId;
  var transitionTypeStr = details.transitionType;
  var transitionTypeVariant = Curry._1(TransitionType.tFromJs, transitionTypeStr);
  var transitionType = transitionTypeVariant !== undefined ? transitionTypeVariant : Js_exn.raiseError("Unknown transitionType: " + transitionTypeStr);
  var transitionQualifiers = transitionQualifiersFromJs(details.transitionQualifiers);
  var timeStamp = details.timeStamp;
  return {
          tabId: tabId,
          url: url,
          processId: processId,
          frameId: frameId,
          parentFrameId: parentFrameId,
          transitionType: transitionType,
          transitionQualifiers: transitionQualifiers,
          timeStamp: timeStamp
        };
}

function fromRecord(record) {
  return {
          tabId: record.tabId,
          url: record.url,
          processId: record.processId,
          frameId: record.frameId,
          parentFrameId: record.parentFrameId,
          transitionType: Curry._1(TransitionType.tToJs, record.transitionType),
          transitionQualifiers: $$Array.map(TransitionQualifier.tToJs, record.transitionQualifiers),
          timeStamp: record.timeStamp
        };
}

function stringify$1(record) {
  return JSON.stringify(fromRecord(record));
}

var Details_t_encode = include.t_encode;

var Details_t_decode = include.t_decode;

var Details$1 = {
  t_encode: Details_t_encode,
  t_decode: Details_t_decode,
  record_encode: record_encode,
  record_decode: record_decode,
  toRecord: toRecord,
  fromRecord: fromRecord,
  stringify: stringify$1
};

var OnCommitted = {
  Details: Details$1
};

var Details$2 = {};

function addListener(logOriginalOpt, listener) {
  var logOriginal = logOriginalOpt !== undefined ? logOriginalOpt : false;
  browser.webNavigation.onDOMContentLoaded.addListener(function (details) {
        if (logOriginal) {
          Curry._2(Log$SmartcutsMacros.chromeEventsWebNav.log2, "Browser.WebNavigation.OnDOMContentLoaded", details);
        }
        return Curry._1(listener, details);
      });
  
}

var OnDOMContentLoaded = {
  Details: Details$2,
  addListener: addListener
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "tabId",
                Decco.intToJson(v.tabId)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "processId",
                Decco.intToJson(v.processId)
              ],
              [
                "frameId",
                Decco.intToJson(v.frameId)
              ],
              [
                "parentFrameId",
                Decco.intToJson(v.parentFrameId)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
  if (tabId.TAG === /* Ok */0) {
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      var processId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "processId"), null));
      if (processId.TAG === /* Ok */0) {
        var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
        if (frameId.TAG === /* Ok */0) {
          var parentFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentFrameId"), null));
          if (parentFrameId.TAG === /* Ok */0) {
            var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
            if (timeStamp.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        tabId: tabId._0,
                        url: url._0,
                        processId: processId._0,
                        frameId: frameId._0,
                        parentFrameId: parentFrameId._0,
                        timeStamp: timeStamp._0
                      }
                    };
            }
            var e = timeStamp._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".timeStamp" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = parentFrameId._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".parentFrameId" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = frameId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".frameId" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = processId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".processId" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = tabId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tabId" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function stringify$2(details) {
  return JSON.stringify(details);
}

var Details$3 = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$2
};

var OnCompleted = {
  Details: Details$3
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "tabId",
                Decco.intToJson(v.tabId)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "frameId",
                Decco.intToJson(v.frameId)
              ],
              [
                "parentFrameId",
                Decco.intToJson(v.parentFrameId)
              ],
              [
                "error",
                Decco.stringToJson(v.error)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
  if (tabId.TAG === /* Ok */0) {
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
      if (frameId.TAG === /* Ok */0) {
        var parentFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentFrameId"), null));
        if (parentFrameId.TAG === /* Ok */0) {
          var error = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "error"), null));
          if (error.TAG === /* Ok */0) {
            var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
            if (timeStamp.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        tabId: tabId._0,
                        url: url._0,
                        frameId: frameId._0,
                        parentFrameId: parentFrameId._0,
                        error: error._0,
                        timeStamp: timeStamp._0
                      }
                    };
            }
            var e = timeStamp._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".timeStamp" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = error._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".error" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = parentFrameId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".parentFrameId" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = frameId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".frameId" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = tabId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tabId" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function stringify$3(details) {
  return JSON.stringify(details);
}

function didOccurInSubFrame(param) {
  return param.frameId !== 0;
}

var Details$4 = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$3,
  didOccurInSubFrame: didOccurInSubFrame
};

var OnErrorOccurred = {
  Details: Details$4
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "sourceTabId",
                Decco.intToJson(v.sourceTabId)
              ],
              [
                "sourceProcessId",
                Decco.intToJson(v.sourceProcessId)
              ],
              [
                "sourceFrameId",
                Decco.intToJson(v.sourceFrameId)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "tabId",
                Decco.intToJson(v.tabId)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var sourceTabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sourceTabId"), null));
  if (sourceTabId.TAG === /* Ok */0) {
    var sourceProcessId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sourceProcessId"), null));
    if (sourceProcessId.TAG === /* Ok */0) {
      var sourceFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sourceFrameId"), null));
      if (sourceFrameId.TAG === /* Ok */0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */0) {
          var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
          if (tabId.TAG === /* Ok */0) {
            var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
            if (timeStamp.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        sourceTabId: sourceTabId._0,
                        sourceProcessId: sourceProcessId._0,
                        sourceFrameId: sourceFrameId._0,
                        url: url._0,
                        tabId: tabId._0,
                        timeStamp: timeStamp._0
                      }
                    };
            }
            var e = timeStamp._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".timeStamp" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = tabId._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".tabId" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = url._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".url" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = sourceFrameId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".sourceFrameId" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = sourceProcessId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sourceProcessId" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = sourceTabId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".sourceTabId" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

var Details$5 = {
  t_encode: t_encode$3,
  t_decode: t_decode$3
};

var OnCreatedNavigationTarget = {
  Details: Details$5
};

var Details$6 = {};

var OnTabReplaced = {
  Details: Details$6
};

var OnHistoryStateUpdated = {
  Details: undefined
};

function isMainFrame(frameId) {
  return frameId === 0;
}

var Helpers = {
  isMainFrame: isMainFrame
};

var isDefined = (function () { return typeof browser.webNavigation !== "undefined"; });

exports.TransitionType = TransitionType;
exports.TransitionQualifier = TransitionQualifier;
exports.transitionQualifiersFromJs = transitionQualifiersFromJs;
exports.transitionQualifiersToJs = transitionQualifiersToJs;
exports.EventFilter = EventFilter;
exports.OnBeforeNavigate = OnBeforeNavigate;
exports.OnCommitted = OnCommitted;
exports.OnDOMContentLoaded = OnDOMContentLoaded;
exports.OnCompleted = OnCompleted;
exports.OnErrorOccurred = OnErrorOccurred;
exports.OnCreatedNavigationTarget = OnCreatedNavigationTarget;
exports.OnTabReplaced = OnTabReplaced;
exports.OnHistoryStateUpdated = OnHistoryStateUpdated;
exports.Helpers = Helpers;
exports.isDefined = isDefined;
/* TransitionType Not a pure module */
